import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router';
import { User as UserIcon } from '@linktivity/link-icons';
import { Link } from '@linktivity/link-ui';
import i18n from '@link/share/i18n';
import { HeaderContext } from './context';
import { HeaderProps } from './header.types';
import Locale from './Locale';
import SearchBox from './SearchBox';
import User from './User';
import styles from './header.module.css';

const Header: FC<HeaderProps> = ({
  logo,
  localeList,
  searchConfig,
  logout,
  loggedIn,
  isPasswordAuth
}) => {
  const { t } = useTranslation();
  const currentLocale = useMemo(() => i18n.language, []);
  const matches = useMatches();
  const disableLang = (
    matches[matches.length - 1]?.handle as { disableLang?: boolean }
  )?.disableLang;
  const defaultSearchConfig = {
    enabled: false,
    onSearch: () => {}
  };

  const finalSearchConfig = searchConfig || defaultSearchConfig;

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <div className={styles.logo}>
            {logo && (
              <Link to="/" className={styles.logoInner}>
                <img src={logo} alt="logo" className={styles.logoImage} />
              </Link>
            )}
          </div>
        </div>
        {finalSearchConfig.enabled && (
          <div className={styles.center}>
            <SearchBox config={finalSearchConfig} />
          </div>
        )}
        <div className={styles.right}>
          <HeaderContext.Provider value={{ logout, isPasswordAuth }}>
            <div className={styles.nav}>
              {!disableLang && <Locale localeList={localeList} />}
              {loggedIn ? (
                <User />
              ) : (
                <Link
                  to={`/${currentLocale}/login`}
                  className={styles.navButton}
                >
                  <UserIcon className={styles.navIcon} />
                  <span className={styles.text}>{t('share.login.button')}</span>
                </Link>
              )}
            </div>
          </HeaderContext.Provider>
        </div>
      </div>
    </header>
  );
};

export default Header;
